import "core-js/modules/es6.function.name";
import "core-js/modules/web.dom.iterable";
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
import border from '@/components/border/borderType';
import leftBar from '@/components/env-bigData/leftBar';
import ratio from '@/components/env-bigData/ratio';
import warn from '@/components/border/warn';
import IwsVideo from '@comp/VideoPlay/IwsVideo';
import fileTable from '@/components/border/fileTable';
import analysis from '@/components/env-bigData/analysis';
import multiHistogram from '@/components/env-bigData/multiHistogram';
import ball from '@/components/env-bigData/ball';
import calendarRange from '@/components/env-bigData/calendarRange';
import pieData from '@/components/env-bigData/pieData';
import multiRowTable from '@/components/border/multiRowTable';
export default {
  props: ['selectedSiteType'],
  computed: {
    classOption: function classOption() {
      return {
        step: .5,
        // 数值越大速度滚动越快
        limitMoveNum: 10,
        // 开始无缝滚动的数据量 this.dataList.length
        hoverStop: true,
        // 是否开启鼠标悬停stop
        direction: 1,
        // 0向下 1向上 2向左 3向右
        // openWatch: true, // 开启数据实时监控刷新dom
        singleHeight: 0,
        // 单步运动停止的高度(默认值0是无缝不停止的滚动) direction => 0/1
        singleWidth: 0,
        // 单步运动停止的宽度(默认值0是无缝不停止的滚动) direction => 2/3
        waitTime: 1000 // 单步运动停止的时间(默认值1000ms)

      };
    }
  },
  components: {
    multiRowTable: multiRowTable,
    multiHistogram: multiHistogram,
    pieData: pieData,
    calendarRange: calendarRange,
    ball: ball,
    border: border,
    leftBar: leftBar,
    ratio: ratio,
    warn: warn,
    IwsVideo: IwsVideo,
    fileTable: fileTable,
    analysis: analysis
  },
  data: function data() {
    return {
      leftInfo: [{
        name: '站点名称',
        icon: 'global',
        value: '洛河崖村',
        unit: ''
      }, {
        name: '面积',
        icon: 'flag',
        value: '1500',
        unit: '㎡'
      }, {
        name: '常住人口',
        icon: 'team',
        value: '800',
        unit: '人'
      }],
      leftBarValue: [75, 69, 17, 6, 3, 18],
      leftBarTitle: ['细微粒物PM2.5', '亚微米颗粒物PM1.0', '臭氧', '一氧化碳', '二氧化硫', '二氧化氮'],
      leftTempList: [{
        title: '温度',
        icon: 'flag',
        unit: '℃',
        value: '14'
      }, {
        title: '湿度',
        icon: 'flag',
        unit: '%',
        value: '71'
      }, {
        title: '气压',
        icon: 'flag',
        value: '75',
        unit: 'Pa'
      }],
      waterWarnList: [],
      orderList: [],
      imgList: [],
      dateList: [{
        title: '透明度',
        value: 32,
        unitName: 'cm'
      }, {
        title: '溶解氧',
        value: 8.54,
        unitName: 'mg/L'
      }, {
        title: '氨氮',
        value: 3,
        unitName: 'mg'
      }],
      // 今日数据
      today: [{
        name: '进水量',
        value: 75,
        unit: 'm³'
      }, {
        name: '出水量',
        value: 78,
        unit: 'm³'
      }, {
        name: '用电总量',
        value: 783,
        unit: 'kW·h'
      }, {
        name: '吨水能耗',
        value: 537,
        unit: 'kW/T'
      }],
      // 汇总数据
      allData: [{
        name: '进水量',
        value: 74354,
        unit: 'm³'
      }, {
        name: '出水量',
        value: 73537,
        unit: 'm³'
      }, {
        name: '用电总量',
        value: 47533,
        unit: 'kW·h'
      }, {
        name: '吨水能耗',
        value: 5375,
        unit: 'kW/T'
      }],
      tabList: [{
        'icon': 'iconfont icon-gengduoxiangmu',
        'title': '项目总览',
        'id': 4
      }, {
        'icon': 'iconfont icon-xiangmu',
        'title': '项目总平',
        'id': 0
      }, {
        'icon': 'iconfont icon-xianxingtubiaozhizuomoban-43',
        'title': '工艺流程',
        'id': 1
      }, {
        'icon': 'iconfont icon-Activity',
        'title': '监测数据',
        'id': 2
      }, {
        'icon': 'iconfont icon-BAI-shiping',
        'title': '视频列表',
        'id': 3
      }],
      selectId: 4,
      historyTableState: true,
      historyTableColumn: [{
        name: '透明度',
        code: 'w0001'
      }, {
        name: '溶解氧',
        code: 'w0002'
      }, {
        name: '氨氮',
        code: 'w0003'
      }],
      historyTableData: [{
        dataTime: '2023-03-20 00:00:00',
        w0001: 15,
        w0002: 16,
        w0003: 17
      }, {
        dataTime: '2023-03-20 01:00:00',
        w0001: 23,
        w0002: 45,
        w0003: 67
      }, {
        dataTime: '2023-03-20 02:00:00',
        w0001: 35,
        w0002: 23,
        w0003: 44
      }, {
        dataTime: '2023-03-20 03:00:00',
        w0001: 13,
        w0002: 33,
        w0003: 53
      }, {
        dataTime: '2023-03-20 04:00:00',
        w0001: 34,
        w0002: 72,
        w0003: 12
      }, {
        dataTime: '2023-03-20 05:00:00',
        w0001: 22,
        w0002: 42,
        w0003: 11
      }, {
        dataTime: '2023-03-20 06:00:00',
        w0001: 32,
        w0002: 8.54,
        w0003: 3
      }]
    };
  },
  mounted: function mounted() {
    // 基础信息原部分
    // this.$refs.leftBar.initBarChart(
    //   this.leftBarValue,
    //   this.leftBarTitle
    // )
    // this.$refs.ball.initBarChart(0.9091, '数据上传率')
    // // 巡排核查部分
    // let time = '2023-03'
    // let month = new Date(time).getMonth() + 1 //获取当前月
    // var year = new Date(time).getFullYear() //获取当前年
    // var datas = [] //新建日期数组
    // var dataLength = new Date(year, month).toJSON().substring(0, 10).split('-')[2] //获取当前年月日期最大值
    // for (var i = 0; i < Number(dataLength); i++) {
    //   let months = month >= 10 ? month : '0' + month
    //   let day = i + 1 >= 10 ? i + 1 : '0' + (i + 1)
    //   datas.push({ date: year + '-' + months + '-' + day, total: Math.floor(Math.random() * 10) % 3 }) //存入数组
    // }
    // this.$refs.calendarRange.initBarChart(time, datas, 2)
    //
    // this.$refs.pieData.initBarChart(
    //   [{
    //     name: '达标',
    //     value: 18
    //   }, {
    //     name: '不达标',
    //     value: 8
    //   }])
    // 反馈工单统计
    var histogramData = {
      date: ['星期一', '星期二', '星期三', '星期四', '星期五', '星期六', '星期日'],
      label: ['一般任务', '较大任务', '重大任务'],
      value: [[3, 2, 5, 7, 1, 1, 3], [8, 6, 2, 1, 8, 2, 1], [5, 6, 4, 2, 5, 8, 5]]
    };
    this.$refs.multiHistogram.initBarChart(histogramData);
    var warnArr = ['黑臭水体溢出', '台风', '陌生人', '危险区域生物闯入'];

    for (var i = 0; i < 10; i++) {
      this.waterWarnList.push({
        siteName: "\u6D1B\u6CB3\u5D16\u6751",
        warnContent: warnArr[i % 4],
        warnTime: "2023-03-".concat(i + 10, " ").concat(i + 10, ":04:05")
      });
      this.imgList.push({
        type_dictText: '入侵',
        siteName: "\u6D1B\u6CB3\u5D16\u6751",
        time: "2023-03-".concat(i + 10)
      });
    }
  },
  methods: {
    onToResetData: function onToResetData() {
      var _this = this;

      this.historyTableState = !this.historyTableState;

      if (!this.historyTableState) {
        this.$nextTick(function () {
          var analysisTime = [];

          _this.historyTableData.forEach(function (item) {
            analysisTime.push(item.dataTime);
          });

          var analysisPop = [];
          var analysisLabelData = [];

          _this.historyTableColumn.forEach(function (item) {
            analysisLabelData.push(item.name);
            var analysisPopObj = {
              data: [],
              title: item.name
            };

            _this.historyTableData.forEach(function (item1) {
              var label = {};
              analysisTime.forEach(function (item2) {
                label.name = item2;
                label.value = item1[item.code];
              });
              analysisPopObj.data.push(label);
            });

            analysisPop.push(analysisPopObj);
          });

          _this.$refs.analysis.initBarChart(analysisPop, analysisTime, analysisLabelData);
        });
      }
    },
    changeTab: function changeTab(id) {
      this.selectId = id;
    },
    back: function back() {
      var _this2 = this;

      this.$refs.ball ? clearInterval(this.$refs.ball.timer) : '';
      this.$nextTick(function () {
        _this2.$emit('back');
      });
    },
    onToVillage: function onToVillage() {
      this.$emit('changeTab', 2);
    }
  }
};